import { forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { HelperService } from './services/helper.service';
import { ApiService } from './services/api.service';
import { AuthStateService } from './services/auth-state.service';
import { AppService } from './services/app.service';
import { environment } from 'projects/environments/environment';
import * as am4core from '@amcharts/amcharts4/core';
import { BillingService } from './services/billing.service';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public loading = true;

  constructor(
    private transloco: TranslocoService,
    private helper: HelperService,
    private api: ApiService,
    private auth: AuthStateService,
    public app: AppService,
    private billing: BillingService,
    private primengConfig: PrimeNGConfig
  ) {}

  ngOnInit(): void {
    registerLocaleData(localeDe, 'de-DE');
    am4core.addLicense(environment.am4LiceneKey);
    const userLang = navigator.language || (navigator as any).userLanguage;
    const regex = new RegExp('de-.+');
    // prime config
    this.primengConfig.overlayOptions = {
      appendTo: 'body'
    };
    // preload all languages
    forkJoin([
      this.transloco.load('en'),
      this.transloco.load('de'),
      this.api.getSysinfo()
    ]).subscribe({
      next: (result: any) => {
        if (userLang === 'de' || regex.test(userLang)) {
          this.helper.setLanguage('de');
        } else {
          this.helper.setLanguage('en');
        }
        if (result[2].data) {
          this.auth.setSysType(result[2].data.env);
          this.auth.setSysMode(result[2].data.mode);
          this.auth.setFeatures(result[2].data.features);
          this.app.setServerSettings(result[2].data.server_settings);
        }
        this.billing.init();
      }
    }).add(() => {
      this.loading = false;
    });
  }

}
